/**
 * Policy — coreBOS `evPolicies` (73x) on evo-gdpr.evolutivo.it.
 * Harvested from evo-mcp-limitless@origin/evo-policies by scripts/harvest/gen_descriptors.py.
 * Frameworks: gdpr,nis2,dlgs81. Type sources per field: docs/harvest-report.md.
 * Regenerate instead of hand-editing; hand edits belong in the generator's SPEC.
 */
export const policyDescriptor = {
    slug: 'cmp_policy',
    kind: 'document',
    label: { singular: 'Policy', plural: 'Policy' },
    table: 'compliance_policy',
    idStrategy: 'sha256',
    fields: [
        { name: 'title', type: 'text', label: 'Titolo', required: true },
        { name: 'policystatus', type: 'text', label: 'Stato' },
        { name: 'policy_type', type: 'text', label: 'Tipo Policy' },
        { name: 'policyisactive', type: 'boolean', label: 'Attiva' },
        { name: 'effectivsince', type: 'date', label: 'Effectivsince' },
        { name: 'policyreviewdate', type: 'date', label: 'Policyreviewdate' },
        { name: 'policyversion', type: 'text', label: 'Policyversion' },
        { name: 'allow_upload', type: 'boolean', label: 'Allow upload' },
        { name: 'model', type: 'text', label: 'Model' },
        { name: 'description', type: 'text', label: 'Descrizione' },
        { name: 'framework_tags', type: 'text', label: 'Framework tags' },
    ],
    relations: [
        { name: 'policytoaccount', kind: 'belongsTo', target: 'account', toEntitySpine: true },
        { name: 'assigned_user', kind: 'belongsTo', target: 'user', toEntitySpine: true },
        { name: 'documents', kind: 'hasMany', target: 'document' },
    ],
    behaviors: { ownership: true, audit: true, softDelete: true, tenantScoped: true, documents: true },
    ui: { mode: 'generated', icon: 'FileProtectOutlined', navGroup: 'Policy', markdown: ['description'], lifecycle: { field: 'policystatus', steps: ['Draft', 'In approvazione', 'Deliberata', 'In uso', 'Archiviata'] }, deadlines: [{ field: 'policyreviewdate' }] },
};
